
import { useState } from 'react';
import AnimateInView from '@/components/ui/animate-in-view';
import { Button } from '@/components/ui/button';

const FeatureVisualization = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <section className="py-16 bg-white overflow-hidden animate-on-view">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <AnimateInView animation="fade-in" className="mb-12 text-center">
            <div className="h-0.5 bg-gold w-20 mx-auto mb-4"></div>
            <h2 className="text-forti-fi-DEFAULT mb-8">Advanced Visualization</h2>
            <p className="text-forti-fi-charcoal max-w-2xl mx-auto">
              Our cutting-edge technology translates complex security data into actionable intelligence through intuitive visualizations.
            </p>
          </AnimateInView>
          
          <AnimateInView animation="scale-in" delay={200}>
            <div 
              className="relative rounded-xl overflow-hidden shadow-xl transition-all duration-700"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <div className={`transition-transform duration-700 ${isHovered ? 'scale-105' : 'scale-100'}`}>
                <img 
                  src="/images/glowing-line-single.jpg" 
                  alt="Forti-Fi perimeter security visualization" 
                  className="w-full h-auto"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent flex items-end"> {/* Increased opacity of gradient */}
                  <div className="p-6 md:p-10 text-white w-full">
                    <h3 className="text-2xl md:text-3xl font-medium mb-4">Visualize Threats in Real-Time</h3>
                    <p className="text-white max-w-2xl mb-6"> {/* Changed text-white/95 to text-white for full opacity */}
                      Our advanced geospatial intelligence transforms invisible security data into actionable insights, allowing you to identify and address potential threats before they materialize.
                    </p>
                    <Button variant="outline" className="border-white text-white hover:bg-white/20 transition-colors">
                      Learn More
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </AnimateInView>
        </div>
      </div>
    </section>
  );
};

export default FeatureVisualization;
